import { Typography } from '@mui/material';
import { InfoContentItem } from 'components/InfoDrawer/InfoContentItem';
import { infoContentPeerGroups } from 'pages/Benchmarking/common/InfoDrawerPeerGroupContent';
import { FormattedMessage } from 'react-intl';
import { InfoAlert } from 'components/alert/InfoAlert';
import { OrderBasedKpiNote } from 'components/InfoDrawer/InfoDrawerKpiNote';
import { useModelService } from 'services/model/model.service';

const infoContentKpis = [
  {
    title: 'insights.measure.orderedGMVGrowth.name',
    description: 'insights.measures.orderedGMVGrowth.marketplace.description_yoy',
  },
  {
    title: 'benchmarking.performance_gap.title',
    description: 'benchmarking.performance_gap.description',
  },
  {
    title: 'benchmarking.financial_impact.title',
    description: 'benchmarking.financial_impact.description',
  },
  {
    title: 'benchmarking.info.content.why_is_the_ordered_gmv_growth_important.title',
    description: 'benchmarking.marketplaces_tab.info.content.why_is_the_ordered_gmv_growth_important.description',
  },
  {
    title: 'model.metric.retQtyRate.name',
    description: 'benchmarking.titles.returns.marketplace.description',
    highlighted: true,
    expectedLabel: true,
  },
  {
    title: 'benchmarking.performance_tab.info.content.why_are_the_return_rates_important.title',
    description: 'benchmarking.marketplace_tab.info.content.why_are_the_return_rates_important.description',
  },
  {
    title: 'benchmarking.performance.section.cancellations',
    description: 'benchmarking.titles.cancellations.marketplace.description',
  },
  {
    title: 'benchmarking.performance_tab.info.content.why_are_the_cancellation_rates_important.title',
    description:
      'benchmarking.performance_tab.info.content.why_are_the_cancellation_rates_important.marketplaces.description',
  },
];

export function MarketplacesInfoContent() {
  const { getMeasure } = useModelService();
  const retQtyRateExpMeasure = getMeasure('retQtyRateExpOD');

  return (
    <div>
      <InfoAlert messageId="benchmarking.info.alert" />

      <Typography variant="body1" sx={{ fontWeight: 400, mb: 3 }}>
        <FormattedMessage id="info.content.helpful_information" defaultMessage="Helpful information" />
      </Typography>

      <InfoContentItem
        titleId="info.content.why_is_this_view_useful"
        descriptionId="benchmarking.marketplaces_tab.info.content.why.useful.description"
      />

      <hr className="my-4 border-snow-200" />

      <div>
        <Typography variant="body1" sx={{ fontWeight: 400, mb: 3 }}>
          <FormattedMessage id="info.content.kpis" defaultMessage="Key Performance Indicators (KPIs)" />
        </Typography>
        <OrderBasedKpiNote />
      </div>

      {infoContentKpis.map(kpi => (
        <InfoContentItem
          key={kpi.title}
          titleId={kpi.title}
          descriptionId={kpi.description}
          highlighted={kpi.highlighted}
          measure={kpi.expectedLabel ? retQtyRateExpMeasure : undefined}
        />
      ))}

      <InfoContentItem
        titleId="benchmarking.titles.additional.timeframe.selection"
        descriptionId="benchmarking.titles.additional.timeframe.selection.description"
      />

      <hr className="my-4 border-snow-200" />
      <Typography variant="body1" sx={{ fontWeight: 400, mb: 3 }}>
        <FormattedMessage id="benchmarking.performance_tab.peer_groups" />
      </Typography>

      {infoContentPeerGroups.map(peerGroup => (
        <InfoContentItem key={peerGroup.title} titleId={peerGroup.title} descriptionId={peerGroup.description} />
      ))}

      <hr className="my-4 border-snow-200" />

      <Typography variant="body1" sx={{ fontWeight: 400, mb: 3 }}>
        <FormattedMessage id="info.content.abbreviations" />
      </Typography>

      <InfoContentItem
        titleId="help.glossary.percentage_points.title"
        descriptionId="help.glossary.percentage_points.description"
      />
    </div>
  );
}
